// react-rails / react_ujs の置き換え (#2463)。
//
// esbuild は webpack の require.context を持たないため、マウント対象コンポーネントを
// 明示登録する。React 島は payrolls#edit と onboarding chat の 2 つだけ。
// `react_component` ヘルパが吐く div[data-react-class][data-react-props] を走査し
// createRoot でマウント/アンマウントする。Turbo ナビゲーションにも追従する。

import { createRoot } from 'react-dom/client';
import CompanyPayrollsTable from './components/CompanyPayrollsTable';
import OnboardingChat from './components/OnboardingChat';

const REGISTRY = { CompanyPayrollsTable, OnboardingChat };

// マウント済みノード -> root の対応。再マウント/アンマウントで二重生成を防ぐ。
const roots = new WeakMap();

const mountAll = () => {
  document.querySelectorAll('[data-react-class]').forEach((el) => {
    if (roots.has(el)) return;
    const Component = REGISTRY[el.dataset.reactClass];
    if (!Component) return;

    const props = el.dataset.reactProps ? JSON.parse(el.dataset.reactProps) : {};
    const root = createRoot(el);
    root.render(<Component {...props} />);
    roots.set(el, root);
  });
};

const unmountAll = () => {
  document.querySelectorAll('[data-react-class]').forEach((el) => {
    const root = roots.get(el);
    if (root) {
      root.unmount();
      roots.delete(el);
    }
  });
};

const start = () => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }
  document.addEventListener('turbo:load', mountAll);
  // Turbo がキャッシュへ退避する前にアンマウントし、二重マウントを避ける。
  document.addEventListener('turbo:before-cache', unmountAll);
};

export default start;
